import React, { FC } from 'react';
import { Selector, Container, Icon } from './styles';
import { Props } from './types';

const Select: FC<Props> = ({ children, ...props }) => {
  return (
    <Container>
      <Selector {...props}>{children}</Selector>
      <Icon />
    </Container>
  );
};

export default Select;
